// extracted by mini-css-extract-plugin
module.exports = {"table":"TemplatesTable_table__2BCVm"};